import { render, staticRenderFns } from "./PageMessages.vue?vue&type=template&id=2edb92c8&"
import script from "./PageMessages.vue?vue&type=script&lang=ts&"
export * from "./PageMessages.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports